import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const FieldForceHeadquarterVersionListTableData = ({
  data,
  index,
  currentPage,
}) => {
  const navigate = useNavigate();
  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}{" "}
      </td>
      <td className="table-each-row-data">{data?.code ? data?.code : "--"}</td>
      <td className="table-each-row-data">{data?.name ? data?.name : "--"}</td>
      <td className="table-each-row-data">
        {data?.state?.name ? data?.state?.name : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.headQuaterDistricts?.length > 0 &&
          data?.headQuaterDistricts?.map((ele, index) => {
            return (
              <span className="slice-word" key={index}>
                <span style={{ color: "#B0B3C7" }}>{index ? " | " : ""}</span>
                {ele?.district?.name}
              </span>
            );
          })}
      </td>
      {data.status == true ? (
        <td className="table-each-row-data color-green">Active</td>
      ) : (
        <td className="table-each-row-data color-danger">Inactive</td>
      )}
      <td className="table-each-row-data">
        {data?.headQuaterVersion?.updatedBy?.name
          ? data?.headQuaterVersion?.updatedBy?.name
          : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.updatedAt
          ? moment(data?.updatedAt).format("DD MMM YYYY, HH:mm A")
          : "--"}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/field-force/head-quarter/version-view/${data?.id}`)
            }
          >
            View
          </button>
        </div>
      </td>
    </tr>
  );
};

export default FieldForceHeadquarterVersionListTableData;
